import React from "react";
import { Form, Button, Radio } from 'antd';
import { craftUseMutation } from '../../hooks';
import CraftFormItems from '../fields';
import CraftConst from '../../craft-const';
import Stands from 'components/stands';
import Hall from 'components/hall';
import { Localize } from "components/service";


const CraftActionForm = ({ event, standsSelectAll, stands, hallID, variables, operation, action }) => {

    const [ form ] = Form.useForm();
    const valueFieldWhere = Form.useWatch('where', form);
    const valueFieldRadio = Form.useWatch('radio', form);
    const allCrafts = CraftConst.craftTypes.map(({ type }) => type);

    const {
        _setCraftActions,
        loadingMutationCraftActions,
    } = craftUseMutation.actions({ variables });


    return (
        <Form
            layout="vertical"
            form={ form }
            className="model-form"
            onFinish={ (values) => {

                _setCraftActions({
                    variables: {
                        action: operation,
                        ee_id: event?.id,
                        stand_id: valueFieldWhere === 'stands_checkboxes' && stands.length > 0 ? stands : [],
                        hall_id: valueFieldWhere === 'stands_hall' && hallID ? hallID : undefined,
                        ...values,
                        craft_type: valueFieldRadio === 'choosen' ? values.craft_type : allCrafts,
                    }
                });

                action();
                form.resetFields();
            } }>

            <Stands.Forms.Fields.SelectWere form={ form } standsSelectAll={ standsSelectAll } stands={ stands } hallID={ hallID } />

            { valueFieldWhere === 'stands_hall' && !hallID &&
                <Hall.Forms.Fields.Select
                    form={ form }
                    ee_id={ event?.id } />
            }

            <Form.Item name='radio' initialValue={ 'choosen' }>
                <Radio.Group className="radio-modal">
                    <Radio value="choosen">
                        <Localize>FORMS.Radio_Label_ChoosenCraft</Localize>
                    </Radio>
                    <Radio value="all">
                        <Localize>FORMS.Radio_Label_AllCrafts</Localize>
                    </Radio>
                </Radio.Group>
            </Form.Item>

            { valueFieldRadio === 'choosen' &&
                <CraftFormItems.SelectType
                    mode="multiple"
                    name="craft_type"
                    form={ form }
                /> }


            <div className="form-btn-holder">

                <Button
                    className="ant-btn ant-btn-secondary bg-light-gray"
                    onClick={ action }
                >
                    <Localize>GLOBAL.Button_Text_Cancel</Localize>
                </Button>

                <Button
                    className="btn-right"
                    type="primary"
                    htmlType="submit"
                    loading={ loadingMutationCraftActions }
                >
                    <Localize>GLOBAL.Button_Text_Save</Localize>
                </Button>
            </div>
        </Form>
    );
};

export default CraftActionForm;


